module.exports = __webpack_public_path__ + "static/img/floor3-img.f0fc3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-img.png
// module id = k0qK
// module chunks = 1